<div class="centrar" id="spinner" #contenedor >
  <p *ngIf="arriba"  class="textoArriba" >{{this.texto}}</p>
  <div class="spinner primary" style="margin-top: 10px;" #spin></div>
  <p *ngIf="!arriba" [style.color]="this.textoColor" >{{this.texto}}</p>
</div>


